import {
  BackgroundIcons,
  BackgroundIconContainer,
  BackgroundIcon,
  BackgroundIconName,
} from "./HomeBackgroundIconsStyles";
import { DESKTOP_APPS, useOpenApp } from "./desktopApps";
import { iconMotionProps } from "../../../../components/Effects/iconMotion";

const HomeBackgroundIcons = () => {
  const openApp = useOpenApp();

  return (
    <BackgroundIcons>
      {DESKTOP_APPS.map((app, index) => {
        return (
          <BackgroundIconContainer
            key={app.name}
            {...iconMotionProps(index)}
            onDoubleClick={() => {
              openApp(app);
            }}
          >
            <BackgroundIcon src={app.iconSrc} />
            <BackgroundIconName>{app.name}</BackgroundIconName>
          </BackgroundIconContainer>
        );
      })}
    </BackgroundIcons>
  );
};

export default HomeBackgroundIcons;
